const prefix = 'ORDERS_';

export const ClientOrderActionTypes = {
  GET_CLIENT_ORDERS: `${prefix}GET_CLIENT_ORDERS`,
  SET_CLIENT_ORDERS: `${prefix}SET_CLIENT_ORDERS`,
  GET_PDF_RESULT: `${prefix}GET_PDF_RESULT`,
  SET_PDF_RESULT_LOADING: `${prefix}GET_PDF_RESULT_LOADING`,
  SET_CLIENT_PRE_INVOICE: `${prefix}SET_CLIENT_PRE_INVOICE`,
  GET_EXTENDED_ORDER_LIST: `${prefix}GET_EXTENDED_ORDER_LIST`,
  SET_CLIENT_ORDERS_INITIAL: `${prefix}SET_CLIENT_ORDERS_INITIAL`,
  SET_COMPLAINT_RESPOND_TIME: `${prefix}SET_COMPLAINT_RESPOND_TIME`,
  SET_REORDER_MODAL: `${prefix}SET_REORDER_MODAL`,
  SET_ORDER_TYPE: `${prefix}SET_ORDER_TYPE`,
  GET_CLIENT_PRE_INVOICE: `${prefix}GET_CLIENT_PRE_INVOICE`,
  GET_COMPLAINT_RESPOND_TIME: `${prefix}GET_COMPLAINT_RESPOND_TIME`,
};

const getOrderList = () => ({ type: ClientOrderActionTypes.GET_CLIENT_ORDERS });
const getPdfResult = (data: { pdfResultId: string }) => ({ type: ClientOrderActionTypes.GET_PDF_RESULT, data: data });
const setPdfResultLoading = () => ({ type: ClientOrderActionTypes.SET_PDF_RESULT_LOADING });
const getExtendedOrderList = () => ({ type: ClientOrderActionTypes.GET_EXTENDED_ORDER_LIST });
const setClientOrdersInitial = () => ({ type: ClientOrderActionTypes.SET_CLIENT_ORDERS_INITIAL });
const setReorderModal = (data: {open: boolean, orderId: string | null}) => ({ type: ClientOrderActionTypes.SET_REORDER_MODAL, data: data });
const setOrderType = (data: { orderType: 'CURRENT' | 'DELIVERED' | 'CANCELED'| 'PRE_INVOICE'}) => ({ type: ClientOrderActionTypes.SET_ORDER_TYPE, data: data });
const getComplaintsRespondTime = () => ({ type: ClientOrderActionTypes.GET_COMPLAINT_RESPOND_TIME });

export const ClientOrderActions = {
  getOrderList: getOrderList,
  getPdfResult: getPdfResult,
  setPdfResultLoading: setPdfResultLoading,
  getExtendedOrderList: getExtendedOrderList,
  setClientOrdersInitial: setClientOrdersInitial,
  setReorderModal: setReorderModal,
  setOrderType: setOrderType,
  getComplaintsRespondTime: getComplaintsRespondTime,
};

